module.exports = {
  API_SERVER: 'https://backend.hi-services.es:1341',
  AWS_ACCESS_KEY_ID: 'AKIARKPXVJBPQXX3NWWU',
  AWS_SECRET_ACCESS_KEY: "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",
};
